// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3VQGS","head":"ProcedureTableInfo_head__3iMHR"};